import React from "react";
import { FaYoutube, FaInstagram, FaFacebook, FaWhatsapp } from "react-icons/fa";
import "./ConnectPage.css";

function ConnectPage() {
  return (
    <div className="connect-page">
      <h1>Stay Connected with ISKCON Ujjain</h1>
      <p>Follow us for updates, events, and spiritual wisdom.</p>

      <div className="social-grid">
        <a
          href="https://youtube.com/iskconujjain"
          target="_blank"
          rel="noopener noreferrer"
          className="social-card youtube"
        >
          <FaYoutube /> YouTube
        </a>

        <a
          href="https://instagram.com/iskconujjain"
          target="_blank"
          rel="noopener noreferrer"
          className="social-card instagram"
        >
          <FaInstagram /> Instagram
        </a>

        <a
          href="https://facebook.com/iskconujjain"
          target="_blank"
          rel="noopener noreferrer"
          className="social-card facebook"
        >
          <FaFacebook /> Facebook
        </a>

        <a
          href="https://www.whatsapp.com/channel/0029Va9jFohEVccPnwkPAJ46"
          target="_blank"
          rel="noopener noreferrer"
          className="social-card whatsapp"
        >
          <FaWhatsapp /> WhatsApp
        </a>
      </div>
    </div>
  );
}

export default ConnectPage;
